/* global gdAlertify */
import { useState, useEffect } from "react"
import axiosInstance from "../config/axiosConfig"
import BuscarPaciente from "./components/BuscarPaciente" // Componente para buscar pacientes
import BuscarAuxiliar from "./components/BuscarAuxiliar" // Componente para buscar auxiliares
import Select from "react-select"
import { useNavigate } from "react-router-dom"
import { formatMoney } from "../utils/utils"

function IngresoAdicionales() {
    const navigate = useNavigate()
    const [pacienteInfo, setPacienteInfo] = useState(null)
    const [auxiliarInfo, setAuxiliarInfo] = useState(null)
    const [auxiliarAdicionalInfo, setAuxiliarAdicionalInfo] = useState(null)
    const [auxiliares, setAuxiliares] = useState([
        { value: 0, label: "Cobrar al cliente" },
        { value: 1, label: "Paga SK" },
    ])

    const today = new Date()

    // Obtener el año, mes y día
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, "0")
    const day = String(today.getDate()).padStart(2, "0")
    const formattedDate = `${year}-${month}-${day}`

    const [datosAdicional, setDatosAdicional] = useState({
        pacienteID: 0,
        auxiliarID: 0,
        auxiliarRemplazoID: 0,
        horasExtras: 0,
        valorTurno: 0,
        valorColacion: 0,
        valorMovilizacion: 0,
        valorOtro: 0,
        motivoAdicional: "",
        fechaAdicional: formattedDate,
        tipoTurno: 1, // 1 = Día, 2 = Noche
    })



    const handleSeleccionPaciente = (paciente) => {
        console.log(paciente)
        setPacienteInfo(paciente) // Guardamos los detalles completos en un estado independiente
        setDatosAdicional((datosAdicional) => ({
            ...datosAdicional,
            pacienteID: paciente.id,
        }))
        let options = [
            { value: 0, label: "Cobrar al cliente" },
            { value: 1, label: "Paga SK" },
        ]
        const nuevosAuxiliares = paciente.auxiliares.map((auxiliar) => ({
            value: auxiliar.id,
            label: `${auxiliar.nombre} ${auxiliar.apellidoPaterno} ${auxiliar.apellidoMaterno} (${auxiliar.rut})`,
        }))

        options = [...options, ...nuevosAuxiliares]
        setAuxiliares(options)
    }

    const handleSeleccionAuxiliar = (auxiliar) => {
        setAuxiliarInfo(auxiliar) // Guardamos los detalles completos en un estado independiente
        if (auxiliar.paciente != null) {
            setPacienteInfo(auxiliar.paciente)
            setDatosAdicional((datosAdicional) => ({
                ...datosAdicional,
                pacienteID: auxiliar.paciente.id,
            }))
            let options = [
                { value: 0, label: "Cobrar al cliente" },
                { value: 1, label: "Paga SK" },
            ]
            const nuevosAuxiliares = auxiliar.paciente.auxiliares.map((auxiliar) => ({
                value: auxiliar.id,
                label: `${auxiliar.nombre} ${auxiliar.apellidoPaterno} ${auxiliar.apellidoMaterno} (${auxiliar.rut})`,
            }))

            options = [...options, ...nuevosAuxiliares]
            setAuxiliares(options)
        }
    }
    const handleSeleccionAuxiliarAdicional = (auxiliar) => {
        setDatosAdicional((datosAdicional) => ({
            ...datosAdicional,
            auxiliarRemplazoID: auxiliar.id,
        }))
        setAuxiliarAdicionalInfo(auxiliar) // Guardamos los detalles completos en un estado independiente
    }

    const handleAuxiliar = (selectedOption) => {
        setDatosAdicional({ ...datosAdicional, auxiliarID: selectedOption ? selectedOption.value : "" })
    }

    const handleChange = (e) => {
        const { name, value } = e.target

        if (name == "horasExtras" && pacienteInfo && pacienteInfo.valoresTurnos.length > 0) {
            const valoresTurnos = pacienteInfo.valoresTurnos[0]
            const valorTurno = (valoresTurnos.valorTurnoAuxiliar / 12) * value
            const valorColacion = 0
            const valorMovilizacion = 0
            const valorOtro = 0

            setDatosAdicional((datosAdicional) => ({
                ...datosAdicional,
                valorTurno,
                valorColacion,
                valorMovilizacion,
                valorOtro,
            }))
        }

        setDatosAdicional((datosAdicional) => ({
            ...datosAdicional,
            [name]: value,
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        gdAlertify.confirm({
            title: "Confirmar Adicional",
            message: '¿Está seguro de crear el adicional?',
            onConfirm: async () => {
                gdAlertify.showLoader()
                try {
                    const response = await axiosInstance.post("/acuerdo-mutuo/adicional", datosAdicional)

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message)
                        navigate("/ingreso-adicionales")
                    } else {
                        gdAlertify.notiError(response.data.message)
                    }
                    gdAlertify.hideLoader()
                } catch (error) {
                    gdAlertify.hideLoader()
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.")
                }
            },
            onCancel: () => {
                gdAlertify.notify("Envío cancelado", "error")
            },
        })
    }

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h1 className="mb-4">Ingreso de Adicionales</h1>

                    {/* Selección de Paciente y Auxiliar */}
                    <div className="border p-4 mb-4">
                        <div className="row g-3 d-flex justify-content-between">
                            <div className="col-md-4">
                                <BuscarPaciente onSelect={handleSeleccionPaciente} conAuxiliares={true} />
                            </div>
                            <div className="col-md-4">
                                <BuscarAuxiliar onSelect={handleSeleccionAuxiliar} conPaciente={true} />
                            </div>
                            <div className="col-md-2 d-flex align-items-end">
                                <button className="btn btn-primary">Seleccionar</button>
                            </div>
                        </div>
                    </div>
                    {/* {DAtos Paciente} */}
                    <div className="border p-4 mb-4">
                        <h5 className="mb-3">Información Paciente</h5>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Nombre del Paciente</label>
                                <p id="nombrePaciente" className="form-control-plaintext">
                                    {pacienteInfo
                                        ? `${pacienteInfo.nombres} ${pacienteInfo.apellidoPaterno} ${pacienteInfo.apellidoMaterno}`
                                        : ""}
                                </p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Dirección</label>
                                <p id="direccion" className="form-control-plaintext">
                                    {pacienteInfo ? pacienteInfo.direccion : ""}
                                </p>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Comuna</label>
                                <p id="comuna" className="form-control-plaintext">
                                    {pacienteInfo ? pacienteInfo.desc_comuna : ""}
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* Seleccion Auxiliar y descuento */}
                    <div className="border p-4 mb-4">
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label">Auxiliar al cual cargar adicional</label>
                                <div className="mb-3">
                                    {auxiliares && auxiliares.length > 0 ? (
                                        <div className="list-group mb-3">
                                            {auxiliares
                                                .filter((aux) => aux.value !== 0 && aux.value !== 1)
                                                .map((auxiliar) => (
                                                    <div key={auxiliar.value} className="list-group-item">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="auxiliarSeleccionado"
                                                                id={`auxiliar-${auxiliar.value}`}
                                                                value={auxiliar.value}
                                                                onChange={() => {
                                                                    // Buscar el auxiliar completo en pacienteInfo.auxiliares
                                                                    const auxCompleto = pacienteInfo?.auxiliares?.find((a) => a.id === auxiliar.value)
                                                                    if (auxCompleto) {
                                                                        setAuxiliarAdicionalInfo(auxCompleto)
                                                                        setDatosAdicional((prev) => ({
                                                                            ...prev,
                                                                            auxiliarRemplazoID: auxCompleto.id,
                                                                        }))
                                                                    }
                                                                }}
                                                                checked={datosAdicional.auxiliarRemplazoID === auxiliar.value}
                                                            />
                                                            <label className="form-check-label" htmlFor={`auxiliar-${auxiliar.value}`}>
                                                                {auxiliar.label}
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                            <div className="list-group-item">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="auxiliarSeleccionado"
                                                        id="buscar-auxiliar"
                                                        value="buscar"
                                                        onChange={() => {
                                                            setAuxiliarAdicionalInfo(null)
                                                            setDatosAdicional((prev) => ({
                                                                ...prev,
                                                                auxiliarRemplazoID: 0,
                                                            }))
                                                        }}
                                                        checked={!auxiliarAdicionalInfo || datosAdicional.auxiliarRemplazoID === 0}
                                                    />
                                                    <label className="form-check-label" htmlFor="buscar-auxiliar">
                                                        Buscar otro auxiliar
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <p className="text-muted">
                                            No hay auxiliares asociados al paciente o no se ha seleccionado un paciente.
                                        </p>
                                    )}

                                    {(!auxiliarAdicionalInfo || datosAdicional.auxiliarRemplazoID === 0) && (
                                        <div className="mt-2">
                                            <BuscarAuxiliar onSelect={handleSeleccionAuxiliarAdicional} />
                                        </div>
                                    )}

                                    {auxiliarAdicionalInfo && (
                                        <div className="mt-2">
                                            <p>
                                                <b>Auxiliar seleccionado: </b>
                                                {`${auxiliarAdicionalInfo.nombre} ${auxiliarAdicionalInfo.apellidoPaterno} ${auxiliarAdicionalInfo.apellidoMaterno}`}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Cobros / Descuentos</label>
                                <Select
                                    options={auxiliares}
                                    value={auxiliares.find((option) => option.value === datosAdicional.auxiliarID)}
                                    onChange={handleAuxiliar}
                                    placeholder="Seleccione cobro/descuento"
                                    isClearable
                                />
                            </div>
                        </div>
                    </div>
                    {/* Ingreso de Adicionales */}
                    <div className="border p-4 mb-4">
                        <h5 className="mb-3">Ingreso de Adicionales</h5>
                        <div className="row g-3">
                            <div className="col-md-12">
                                <label htmlFor="fechaAdicional" className="form-label">
                                    Fecha Adicional
                                </label>
                                <input
                                    type="date"
                                    id="fechaAdicional"
                                    name="fechaAdicional"
                                    onChange={handleChange}
                                    value={datosAdicional.fechaAdicional}
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="tipoTurno" className="form-label">Tipo de Turno</label>
                                <select
                                    id="tipoTurno"
                                    name="tipoTurno"
                                    value={datosAdicional.tipoTurno}
                                    onChange={handleChange}
                                    className="form-control"
                                >
                                    <option value={1}>Día</option>
                                    <option value={2}>Noche</option>
                                </select>
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="horasExtras" className="form-label">
                                    Horas Extras
                                </label>
                                <input
                                    type="number"
                                    id="horasExtras"
                                    name="horasExtras"
                                    onChange={handleChange}
                                    value={datosAdicional.horasExtras}
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="turnoExtras" className="form-label">
                                    Valor Extra
                                </label>
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">$</div>
                                    </div>
                                    <input
                                        type="number"
                                        id="valorTurno"
                                        name="valorTurno"
                                        onChange={handleChange}
                                        value={formatMoney(datosAdicional.valorTurno)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="colacionExtra" className="form-label">
                                    Colación Extra
                                </label>
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">$</div>
                                    </div>
                                    <input
                                        type="number"
                                        id="valorColacion"
                                        name="valorColacion"
                                        onChange={handleChange}
                                        value={formatMoney(datosAdicional.valorColacion)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="movilizacionExtra" className="form-label">
                                    Movilización Extra
                                </label>
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">$</div>
                                    </div>
                                    <input
                                        type="number"
                                        id="valorMovilizacion"
                                        name="valorMovilizacion"
                                        onChange={handleChange}
                                        value={formatMoney(datosAdicional.valorMovilizacion)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="motivoAdicional" className="form-label">
                                    Motivo del Adicional
                                </label>
                                <textarea
                                    id="motivoAdicional"
                                    name="motivoAdicional"
                                    onChange={handleChange}
                                    value={datosAdicional.motivoAdicional}
                                    className="form-control"
                                    rows="2"
                                ></textarea>
                            </div>
                        </div>
                    </div>

                    {/* Resumen de Ingreso de Movimientos */}
                    <div className="border p-4">
                        <h5 className="mb-3">Resumen de Ingreso de Movimientos</h5>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Nombre de Auxiliar de Reemplazo</th>
                                    <th>Turno/Horas Extras a Pagar</th>
                                    <th>Movilización a Pagar</th>
                                    <th>Colación a Pagar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{auxiliarAdicionalInfo ? auxiliarAdicionalInfo.nombre : ""}</td>
                                    <td>{formatMoney(datosAdicional.valorTurno)}</td>
                                    <td>{formatMoney(datosAdicional.valorMovilizacion)}</td>
                                    <td>{formatMoney(datosAdicional.valorColacion)}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="text-center">
                            <button className="btn btn-success" onClick={handleSubmit}>
                                Registrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IngresoAdicionales

